import Commons from '../../../../../Services/Common/Common';

export const QRDialog_Schema = {
  mapper: {
    /** TBM 정보 삭제 DeleteTbmNewD1 */
    delete1: {
      SessionCd: (context) =>
        Commons.EncryptAES(context.sessionCd?.toString() ?? ''),
    },
    /** DeleteTbmNewD4 — 단일 참가자 DB 삭제 */
    delete2: {
      SessionCd: (context) =>
        Commons.EncryptAES(context.sessionCd?.toString() ?? ''),
      UserId: (context) =>
        Commons.EncryptAES(context.targetUserId ?? ''),
    },
  },
};
